import CreditScoreChart from "./CreditScoreChart";

export default CreditScoreChart;
